const hasMinLength = minLength => ({
  errorMessage: 'ERROR_HAS_MIN_LENGTH',
  errorMessageParams: { minLength },
  rule: value => value && value.length >= minLength,
});

export default hasMinLength;
